/** Wallets API calls (typed). No wallet create/delete endpoints exist; the only
 *  mutation is the official top-up. */

import { apiGet, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiWallet } from "./wallets.adapter";

export interface WalletsListParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  clientId?: string;
}

export const walletsApi = {
  list: (params: WalletsListParams = {}) =>
    apiGet<PaginatedResponse<ApiWallet>>("/wallets", params as QueryParams),
  alerts: (params: WalletsListParams = {}) =>
    apiGet<PaginatedResponse<ApiWallet>>("/wallets/alerts", params as QueryParams),
  /** body: { amountUsd, exchangeRate?, source?, note? } — exchangeRate defaults server-side. */
  topup: (id: string, body: Record<string, unknown>) => apiPost<ApiWallet>(`/wallets/${id}/topup`, body),
};
